export default __webpack_public_path__ + "static/media/accessory-ridged-griddle.be1017d2.png";